import { createContext } from 'react';

type HelpContext = {
  keywords: string[];
  keywordsStack: string[][];
  setKeywords: (keywords: string[]) => void;
  unsetKeywords: (keywords: string[]) => void;
};
const context = createContext<HelpContext>({
  keywords: [],
  keywordsStack: [],
  setKeywords: undefined as any,
  unsetKeywords: undefined as any,
});
export default context;
